const API_ENDPOINTS = {
  REACT_APP_URL: process.env.REACT_APP_URL,
  AUTH_SERVICE: process.env.REACT_APP_AUTH_SERVICE_API_ENDPOINT_URL,
  ADMIN_SERVICE: process.env.REACT_APP_ADMIN_SERVICE_API_ENDPOINT_URL,
};

const dev = {
  ...API_ENDPOINTS,
};

const uat = {
  ...API_ENDPOINTS,
};

const prod = {
  ...API_ENDPOINTS,
};

const test = {
  ...API_ENDPOINTS,
};

const getEnv = () => {
  switch (process.env.REACT_APP_NODE_ENV) {
    case 'development':
      return dev;
    case 'uat':
      return uat;
    case 'prod':
      return prod;
    case 'test':
      return test;
    default:
      break;
  }
};

export const env = getEnv();
